<template>
  <form :class="formMode" @submit.prevent="formSubmit" onsubmit="this.reset()">
    <span class="check"></span>
    <input
      :class="{ 'form-dark': mode === 'dark', 'dark-mode': mode === 'dark' }"
      type="text"
      placeholder="Create a new todo"
      v-model.trim="title"
    />
  </form>
</template>

<script>
export default {
  props: ["mode"],
  data() {
    return {
      title: "",
    };
  },
  methods: {
    formSubmit() {
      if (!this.title) {
        return;
      }

      const project = {
        title: this.title,
        complete: false,
        id: Math.random() * 100,
      };

      if (process.env.VUE_APP_URI) {
        fetch(process.env.VUE_APP_URI, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(project),
        })
          .then(() => this.$emit("createItem", project))
          .catch((e) => console.log(e));
      }
      this.$emit("createItem", project);

      this.title = "";
    },
  },

  computed: {
    formMode() {
      return this.mode === "light" ? "form-light" : "form-dark";
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  width: 54rem;
  height: 6.4rem;
  z-index: 999;
  display: flex;
  border-radius: 5px;
  overflow: hidden;

  @media only screen and (max-width: 600px) {
    width: 32rem;
  }
}

.light-mode {
}

.dark-mode {
  color: #3a7cfd;
  text-shadow: 0px 0px 0px #c8cbe7;
  -webkit-text-fill-color: transparent;
}

input {
  border: none;
  font-size: 1.8rem;
  font-family: inherit;
  flex: 1;

  &:focus {
    outline: none;
  }
}

.form-light {
  background-color: #fff;
}

.form-dark {
  background-color: #25273d;
}

.check {
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
  margin: 0 2.4rem;
  border: 1px solid #e3e4f1;
  border-radius: 50%;
  align-self: center;
}
</style>
